import { useCallback, useEffect, useState } from "react";
import ControlledAsyncSelectInput from "../ControlledAsyncSelectInput";
import { useAirlinesOptions } from "./hooks";

export default function AirlinesAutocompleteInput({
  bold = false,
  handleChange,
  id,
  required = false,
  placeHolder,
  clear,
  preSelectedValue,
}) {
  const [value, setValue] = useState(null);

  const { loadAirlinesOptions } = useAirlinesOptions();

  const loadOptions = useCallback(
    async (input, callback) => {
      if (input.length <= 1) {
        callback([]);
        return;
      }

      const airlines = await loadAirlinesOptions(input);
      callback(airlines);
    },
    [loadAirlinesOptions]
  );

    useEffect(() => {
    if (clear) {
      setValue(null);
    } else if (preSelectedValue) {
      setValue({ value: "", label: preSelectedValue });
    }
  }, [preSelectedValue, clear]);

  const handleValueChange = (value) => {
    setValue(value);
    handleChange(value);
  };

  return (
    <ControlledAsyncSelectInput
      loadOptions={loadOptions}
      handleSelect={handleValueChange}
      placeholder={placeHolder}
      required={required}
      id={id}
      bold={bold}
      selectedData={value}
    />
  );
}